export const configConstants = {
    CHANGE_TITLE: 'CHANGE_TITLE',
}
